import { render, staticRenderFns } from "./ListPostDetailedItem.vue?vue&type=template&id=d81c10d4&"
import script from "./ListPostDetailedItem.vue?vue&type=script&lang=js&"
export * from "./ListPostDetailedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports